(function () {
    'use strict';

    // @ngInject
    function DoneOnboardingModalControllerCtor($scope, $injector, $q, $state, ConfettiService, $timeout, UsersManager, SetupGuideService, $modalInstance, OnboardingService, AnalyticsService,
                                               ModelFactory, WorkspacesManager, WorkspaceFileService, workspace, WorkspaceFilesManager, workspaceFile, UIUtils) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'DoneOnboardingModalController';
        AnalyticsService.trackPageView(this, 'View');

        this.$q = $q;
        this.UIUtils = UIUtils;
        this.AnalyticsService = AnalyticsService;
        this.$state = $state;
        this.UsersManager  = UsersManager;
        this.$timeout = $timeout;
        this.SetupGuideService = SetupGuideService;
        this.$modalInstance = $modalInstance;
        this.OnboardingService = OnboardingService;
        this.ModelFactory = ModelFactory;
        this.WorkspacesManager = WorkspacesManager;
        this.WorkspaceFileService = WorkspaceFileService;
        this.WorkspaceFilesManager = WorkspaceFilesManager;
        this.workspace = workspace;
        this.workspaceFile = workspaceFile;
        this.ConfettiService = ConfettiService;

        this.currStep = 1;
        this.mailTo = '';
        this.sendInvoiceSubmitted = false;
        this.currUser = this.UsersManager.getCurrUser();
        this.ConfettiService.show({position: 'bottom', count:300});

        this.$modalInstance.onBeforeClose = this.onBeforeClosingDoneOnboardingModal.bind(this);
    }

    Controllers.DoneOnboardingModalController = Class(Controllers.BaseController, {
        constructor: DoneOnboardingModalControllerCtor,

        clearValidations : function clearValidations() {
            this.sendInvoiceForm.email.$setValidity("own_email", true);
            this.sendInvoiceForm.email.$setValidity("email_server", true);
            this.sendInvoiceForm.email.$setValidity("general", true);
        },

        onboardingDoneModalEmailStep : function onboardingDoneModalEmailStep() {
            this.currStep = 2;
        },

        onBeforeClosingDoneOnboardingModal: function onBeforeClosingDoneOnboardingModal() {
            this.ConfettiService.hide();

            var deferred = this.$q.defer();
            deferred.resolve();
            return deferred.promise;

        },

        close: function close() {
            this.$modalInstance.close();
        },

        takeMeToSetupGuide: function takeMeToSetupGuide() {
            this.close();
            this.SetupGuideService.completeStepByKey('invoice');
            this.$state.go(this.AppStates.root_core_navigation_onboardingSetupGuide);
        },

        validateEmailAddress: function validateEmailAddress() {

            if (this.mailTo === this.currUser.email) {
                this.sendInvoiceForm.email.$setValidity("own_email", false);

                this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.action, {
                    unique: 'fail_sending_email_invoice_using_own_email_address',
                    page: 'onboarding_invoice_preview'
                });

            } else {
                this.sendInvoiceForm.email.$setValidity("own_email", true);
            }

            if (!this.sendInvoiceForm.email.$valid) {
                var result = this.$q.defer();
                result.reject({});
                return result.promise;
            }

            return this.UsersManager.getUserByEmail(this.mailTo)
        },

        _replaceInputWithName: function _replaceInputWithName(body, name) {
            return this.UIUtils.replaceHtmlInputsWithString(body, name);
        },

        sendInvoiceByMail: function sendInvoiceByMail() {
            if (this.sendInvoiceSubmitted) {
                return;
            }

            this.clearValidations();

            var _this = this;
            this.sendInvoiceSubmitted = true;
            this.validateEmailAddress()
                .then(function success() {
                    _this.currStep = 3;
                    _this.sendInvoiceForm.email.$setValidity("email_server", true);

                    _this._createUser()
                        .then(function sendEmail(resp) {
                            var email = _this.workspaceFile.getEmailToSend();
                            return _this.WorkspaceFileService.sendToUser(_this.workspaceFile, resp.user, email.subject, _this._replaceInputWithName(email.html_body, resp.user.first_name), true, {})
                                .then(function() {

                                    _this.AnalyticsService.track(_this, _this.AnalyticsService.analytics_events.action, {
                                        unique: 'send_email_invoice_succeeded',
                                        page: 'onboarding_invoice_preview'
                                    });

                                    _this.takeMeToSetupGuide();
                                });
                        })
                        .catch(function() {
                            _this.currStep = 2;
                            _this.sendInvoiceForm.email.$setValidity("general", false);
                            _this.sendInvoiceSubmitted = false;
                        });
            })
            .catch(function error(resp) {
                _this.sendInvoiceSubmitted = false;
                if(resp.data && resp.data.error_message === "Invalid Email Address") {
                    _this.sendInvoiceForm.email.$setValidity("email_server", false);
                } else {
                    _this.sendInvoiceForm.email.$setValidity("email_server", true);
                }
            });
        },

        _createUser: function _createUser() {
            this.user = this.ModelFactory.newUserModel();
            this.user.system_user_type = 'client';
            this.user.email = this.mailTo;
            this.user.full_name = this.mailTo.split('@')[0];

            var saveUserDefer = this.$q.defer();

            this.user.workspace_role = 'host';
            this.WorkspacesManager.saveMember(this.workspace._id, this.user).then(function saveMemberSuccess() {
                saveUserDefer.resolve({user: this.user, projectId: this.workspace.event._id, workspaceId: this.workspace._id});
            }.bind(this)).catch(function saveMemberError(resp) {
                saveUserDefer.reject(resp.data);
            }.bind(this));


            return saveUserDefer.promise;
        }
    });
}());